module.exports = __webpack_public_path__ + "img/scope2.7057ddbe.png";